/**
 * Created by DemonRay on 2019/3/22.
 */
import utils from '../../utils'
import {
	nodeTypeToImage
} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/defaults/node-types";

const defaults = {
	container: false,
	addWhenDrop: true,
	nodeTypes: [],
	tapPlacementMoveThresholdPx: 6,
}

class DragAddNodes {
	constructor(cy, params) {
		this.cy = cy
		this._options = Object.assign({}, defaults, params)
		this._pendingTapPlacementShapeId = ""
		this._placementGesture = null
		this._options.nodeTypes.forEach(item => {
			item.width = item.width || 76
			item.height = item.height || 76
			item.category = item.category || 'other'
		})

		if (this._options.nodeTypes.length < 1) return
		this._initShapePanel()
		this._initShapeItems()
		if (!params.readonly) {
			this._initEvents()
		}
	}

	_initShapeItems() {
		let shapes = this._options.nodeTypes.filter(item => !item.isExcluded)
		shapes.forEach(item => {
			item._id = utils.guid()
		})
		let categorys = {}
		let other = []
		shapes.forEach(item => {
			if (item.category) {
				if (categorys[item.category]) {
					categorys[item.category].push(item)
				} else {
					categorys[item.category] = [item]
				}
			} else {
				other.push(item)
			}
		})
		if (other.length) {
			categorys.other = other
		}
		let readonlyClass = this._options.readonly ? "readonly" : ""
		let categoryDom = Object.keys(categorys).map(item => {
			let shapeItems = categorys[item].map(data => {
				return `
<div data-type="${data.type}" data-shape-id="${data._id}" class="text-center col-6 px-0 mb-4">
	<img src="${data.src || nodeTypeToImage[data.type]}"  alt="${data.label}" class="shape-item" draggable="true" data-id="${data._id}" />
	<div class="text-center bold">${data.label}</div>
</div>
`
			}).join('')
			return `<div class="category" style="margin-bottom: 15px;">

                  <div class="title">${item}</div>
                  <div class="shapes qw-row ${readonlyClass}">${shapeItems}</div>
                </div>`
		}).join('')
		this._shapePanel.innerHTML =
		`<div style="margin-bottom: 150px;">
			${categoryDom}
		</div>`
	}

	_initEvents() {
		let rightContainers = this.cy.container()
		let handler = (e) => {
			e.preventDefault()
		}

		let dataTransfer = new DataTransfer()
		utils.query('.shape-item').forEach(item => {
			item.addEventListener('dragstart', (e) => {
				console.log("addEles start: e = ", e);
				this.clearTapPlacement()
				dataTransfer = new DataTransfer();
				let data = e.dataTransfer || dataTransfer
				let shapeId = this.getShapeIdFromTarget(e.target)
				let shape = this._options.nodeTypes.find(item => item._id === shapeId)
				data.setData('id', shapeId)
				this.cy.trigger('cyeditor.addnodestart', {
					sourceEvent: e,
					dataTransfer: data,
					shape,
					triggerType: e.type,
				})
			})
			item.addEventListener('click', (e) => {
				console.log("addEles start: e = ", e);
				let shapeId = this.getShapeIdFromTarget(e.target)
				let shape = this._options.nodeTypes.find(item => item._id === shapeId)
				this.armTapPlacement(shapeId)
				this.cy.trigger('cyeditor.addnodestart', {
					sourceEvent: e,
					shape,
					triggerType: e.type,
				})
			})
		});

		rightContainers.addEventListener('drop', e => {
			e.preventDefault()
			console.log("addEles end: e = ", e);
			let data = (e.dataTransfer || dataTransfer)
			if(!data){
				return
			}

			let shapeId = data.getData('id')
			dataTransfer = null
			if(!this.isEventInsideContainer(e, rightContainers)){
				return
			}
			if(!shapeId){
				return
			}

			let rect = {x: e.offsetX, y: e.offsetY}
			const shape = this._options.nodeTypes.find(item => item._id === shapeId)
			console.log("addEles end: shape = ", shape)
			this.cy.trigger('cyeditor.addnodeplaceattempt', {
				shape,
				triggerType: 'drop',
			})
			this._addNodeToCy(shape, rect)
			this.clearTapPlacement()
		})

		rightContainers.addEventListener('mousedown', e => {
			this.startPlacementGesture(e, 'click')
		})
		window.addEventListener('mousemove', e => {
			this.updatePlacementGesture(e)
		})
		window.addEventListener('mouseup', e => {
			this.finishPlacementGesture(e)
		})
		rightContainers.addEventListener('touchstart', e => {
			this.startPlacementGesture(e, 'touchstart')
		}, {passive: true})
		window.addEventListener('touchmove', e => {
			this.updatePlacementGesture(e)
		}, {passive: true})
		window.addEventListener('touchend', e => {
			this.finishPlacementGesture(e)
		}, {passive: true})
		window.addEventListener('touchcancel', () => {
			this.resetPlacementGesture()
		}, {passive: true})
		this.cy.on('cyeditor.cancelnodeplacement', () => {
			this.clearTapPlacement()
		})

		rightContainers.addEventListener('dragenter', handler)
		rightContainers.addEventListener('dragover', handler)
	}

	armTapPlacement(shapeId) {
		this._pendingTapPlacementShapeId = shapeId || ""
		this.resetPlacementGesture()
	}

	clearTapPlacement() {
		this._pendingTapPlacementShapeId = ""
		this.resetPlacementGesture()
	}

	startPlacementGesture(event, triggerType) {
		if(!this._pendingTapPlacementShapeId){
			return
		}

		let point = this.getGesturePoint(event)
		if(!point){
			return
		}

		this._placementGesture = {
			startX: point.clientX,
			startY: point.clientY,
			lastX: point.clientX,
			lastY: point.clientY,
			triggerType,
			hasMoved: false,
		}
	}

	updatePlacementGesture(event) {
		if(!this._placementGesture){
			return
		}

		let point = this.getGesturePoint(event)
		if(!point){
			return
		}

		this._placementGesture.lastX = point.clientX
		this._placementGesture.lastY = point.clientY
		let distance = this.calculateDistance(
			this._placementGesture.startX,
			this._placementGesture.startY,
			point.clientX,
			point.clientY
		)
		if(distance > this._options.tapPlacementMoveThresholdPx){
			this._placementGesture.hasMoved = true
		}
	}

	finishPlacementGesture(event) {
		if(!this._placementGesture){
			return
		}

		let gesture = this._placementGesture
		let point = this.getGesturePoint(event)
		this.resetPlacementGesture()
		if(!point){
			return
		}
		if(gesture.hasMoved){
			return
		}

		let container = this.cy.container()
		let bounds = container?.getBoundingClientRect?.()
		if(!bounds || !this.isPointInsideRect(point.clientX, point.clientY, bounds)){
			return
		}

		let shape = this._options.nodeTypes.find(item => item._id === this._pendingTapPlacementShapeId)
		if(!shape){
			this.clearTapPlacement()
			return
		}

		let rect = {
			x: point.clientX - bounds.left,
			y: point.clientY - bounds.top,
		}
		this.cy.trigger('cyeditor.addnodeplaceattempt', {
			shape,
			triggerType: gesture.triggerType,
		})
		this._addNodeToCy(shape, rect)
		this.clearTapPlacement()
	}

	resetPlacementGesture() {
		this._placementGesture = null
	}

	getGesturePoint(event) {
		if(event.changedTouches && event.changedTouches[0]){
			return event.changedTouches[0]
		}
		return event
	}

	calculateDistance(startX, startY, nextX, nextY) {
		let deltaX = nextX - startX
		let deltaY = nextY - startY
		return Math.sqrt(deltaX * deltaX + deltaY * deltaY)
	}

	isPointInsideRect(clientX, clientY, rect) {
		return clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom
	}

	isEventInsideContainer(event, container) {
		let isInside = container === event.target || container?.contains?.(event.target)
		console.log("addEles end: isInside = ", isInside);
		return isInside
	}

	getShapeIdFromTarget(target) {
		return target?.getAttribute?.('data-id') || target?.closest?.('[data-shape-id]')?.getAttribute?.('data-shape-id') || ""
	}

	_addNodeToCy(nodeData, rect) {
		let {type = null, width, height, bg, opacity, border, name = '', points, buildIn = false, src} = nodeData
		let {data = {}, ...scratchData} = nodeData
		let dataLocal = {id: '' + new Date().getTime(), type, name, label: name, width, height, ...data}
		if(bg){
			dataLocal.bg = bg
		}
		if(opacity){
			dataLocal.opacity = opacity
		}
		if(border){
			dataLocal.border = border
		}
		if (!buildIn) {
			dataLocal.image = src
		}
		let node = {
			group: 'nodes',
			data: dataLocal,
			scratch: {
				...scratchData,
				addedFromDragAddNodes: true,
			}, //non-serilizable data that we use to store node level state, like predefined image
			position: rect
		}
		if (points) {
			node.data.points = points
		}
		console.log("addEles: node = ", node)
		console.log("addEles: this._options.addWhenDrop = ", this._options.addWhenDrop)
		if (this._options.addWhenDrop) {
			this.cy.trigger('cyeditor.addnode', node)
		}
	}

	_initShapePanel() {
		let {_options} = this
		if (_options.container) {
			if (typeof _options.container === 'string') {
				this._shapePanel = utils.query(_options.container)[0]
			} else if (utils.isNode(_options.container)) {
				this._shapePanel = _options.container
			}
			if (!this._shapePanel) {
				console.error('There is no any element matching your container')
			}
		} else {
			this._shapePanel = document.createElement('div')
			document.body.appendChild(this._shapePanel)
		}
	}
}

export default (cytoscape) => {
	if (!cytoscape) {
		return
	}

	cytoscape('core', 'dragAddNodes', function (params) {
		return new DragAddNodes(this, params)
	})
}
